import React, { forwardRef, HTMLAttributes } from 'react';
import useImage from 'common/components/useImage';
import { isImgix } from 'common/utils/assets';
import Loader from 'common/components/Loader';

type Props = {
	src: string;
	alt?: string;
} & HTMLAttributes<HTMLImageElement>;

const ImageLoadable = forwardRef<HTMLImageElement, Props>(({ src, alt, ...props }: Props, ref) => {
	const image = useImage(src);

	// show fully loaded image
	if (image.loaded) {
		return <img {...props} src={src} alt={alt} ref={ref} draggable={false} />;
	}

	// render low quality image
	if (isImgix(src)) {
		const url = new URL(src);
		url.searchParams.set('w', '50');
		url.searchParams.set('q', '5');
		url.searchParams.set('blur', '20');
		return <img {...props} src={decodeURIComponent(url.href)} alt={alt} ref={ref} draggable={false} />;
	}

	// render loader
	return <Loader color="black" fullFrame bgColor="rgba(255, 255, 255, 0.18)" />;
});

export default React.memo(ImageLoadable);
